import { render } from "./vendor_list.vue?vue&type=template&id=58c7ed4a&scoped=true"
import script from "./vendor_list.vue?vue&type=script&lang=js"
export * from "./vendor_list.vue?vue&type=script&lang=js"

import "./vendor_list.vue?vue&type=style&index=0&id=58c7ed4a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c7ed4a"]])

export default __exports__